<template>
  <div>
    <div style="border: 1px solid">
      <div class="print-footer-info" :style="footerStyle">
        <div>
          * &nbsp;&nbsp; The supplier shall provide a written and detailed delivery schedule to Sixty Asia Investments
          Limited
          ("Sixty") for all the goods included in the work order within 20 (twenty) days from the receipt of the order.
        </div>
        <div>
          * &nbsp;&nbsp; Place of production: The supplier guarantees that the above order will be produced in
          _______________________________ (specify the Country).
        </div>
        <div>* &nbsp;&nbsp; If the order is produced in a different Country, the Supplier must inform Sixty and must
          receive her
          approval.
        </div>
        <div>
          * &nbsp;&nbsp; Sixty has the right to modify any part of this order as a result of emerging needs and/or force
          majeure by
          informing the Supplier in writing via email/fax.
        </div>
      </div>
    </div>
    <div class="print-footer-page">
      <div>{{info.printDate}}</div>
      <div>{{`page ${currentPage} of ${totalPage}`}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "print-footer",
    props: {
      info: {
        type: Object,
        default: () => {
        }
      },
      currentPage: {
        type: Number | String,
        default: ''
      },
      totalPage: {
        type: Number | String,
        default: ''
      }
    },
    computed: {
      footerStyle() {
        return {
          'display': `grid`,
          'grid-template-columns': `1fr`,
          'grid-auto-flow': 'column',
          'grid-template-rows': `repeat(5, auto)`,
          'grid-column-gap': 0,
          'grid-row-gap': 0,
          'margin': `12px 0`,
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .print-footer-info > div {
    text-indent: 2em;
    word-break: break-word;
    font-size: 12px;
    line-height: 24px;
    font-family: SimSun;
  }

  .print-footer-page {
    display: flex;
    justify-content: flex-end;
    gap: 22px;
    font-size: 12px;
    line-height: 24px;
    font-family: SimSun;
  }
</style>